import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Token } from '../../app/ApiGen';
import { CardState } from './types';

const initialState: CardState = {
  loading: false,
  error: undefined,
  current: undefined,
  selectedItemId: undefined,
};

const cardSlice = createSlice({
  name: 'cardSlice',
  initialState,
  reducers: {
    getCurrentCardAction: (
      state: CardState,
      action: PayloadAction<{ selectedItemId: string; organisationSlug: string }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: true,
      error: undefined,
    }),
    setCurrentCardAction: (state: CardState, action: PayloadAction<{ card: Token }>) => ({
      ...state,
      selectedItemId: action.payload.card.id,
      loading: false,
      error: undefined,
      current: action.payload.card,
    }),
    setCardErrorAction: (state: CardState, action: PayloadAction<{ error: Error; selectedItemId: string }>) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: false,
      error: action.payload.error,
    }),
    clearCurrentCardAction: (state: CardState) => ({
      ...state,
      selectedItemId: undefined,
      loading: false,
      error: undefined,
      current: undefined,
    }),
  },
});

export const { actions: cardActions, reducer: cardReducers } = cardSlice;
